import {
  Directive,
  ElementRef,
  HostListener,
  AfterViewInit,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[phoneFormatter]'
})
export class PhoneFormatterDirective implements AfterViewInit, OnChanges {

  @Input('ngModel') modelValue: any;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngAfterViewInit(): void {
    // Format after Angular applies the initial ngModel value
    setTimeout(() => {
      this.setFormattedValue(this.modelValue);
    }, 500);
  }

  /**
   * The number usually arrives from the server AFTER the field is created.
   * Only the first value used to be formatted (once, after 500 ms), and if
   * that ran with the still-empty value it blanked the box although the
   * model held the user's verified number — the field looked empty next to
   * "מספר מאומת". Re-format whenever the bound value changes.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modelValue'] && !changes['modelValue'].firstChange) {
      setTimeout(() => this.setFormattedValue(this.modelValue));
    }
  }

  @HostListener('ngModelChange', ['$event'])
  onModelChange(value: string) {
    this.setFormattedValue(value);
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.setFormattedValue(value);
  }

  private setFormattedValue(raw: string) {
    const formatted = this.normalizeAndFormat(raw);
    this.el.nativeElement.value = formatted;
  }

  private normalizeAndFormat(raw: string): string {
    if (!raw) return '';

    let digits = raw.replace(/\D+/g, '');

    if (digits.startsWith('972')) {
      digits = digits.substring(3);
    }

    if (!digits.startsWith('0') && digits.length > 0) {
      digits = '0' + digits;
    }

    digits = digits.substring(0, 10);

    if (digits.length !== 10) return digits;

    const p1 = digits.substring(0, 3);
    const p2 = digits.substring(3, 6);
    const p3 = digits.substring(6);

    return `${p1}-${p2}-${p3}`;
  }
}
